import { collecteRoutes, collecteNavigationItems } from "./router";
/**
 * Collecte Module
 * Back-office for "Collecte Digitale" donation forms (list + create, then wizard).
 */
export class CollecteModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[CollecteModule] Registered");
        return {
            id: "collecte",
            name: "Collecte Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        return collecteRoutes;
    }
    getNavigationItems() {
        return collecteNavigationItems;
    }
    getComponent() {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[CollecteModule] Unregistered");
        this.contracts = null;
    }
}
export default new CollecteModule();
